﻿import {DependencyList, useRef} from "react";

export function useInitialize(fn: () => void, deps: DependencyList): void {
	const hasRun = useRef(false);
	const prevDeps = useRef<DependencyList>(undefined);

	const depsChanged = !prevDeps.current ||
		deps.some((dep, i) => !Object.is(dep, prevDeps.current![i]));

	if (!(!hasRun.current || depsChanged)) {
		return;
	}

	hasRun.current = true;
	prevDeps.current = deps;
	fn();
}
